import BreakPoint from '@naruto/naruto-theme/src/base/global/BreakPoint';
import { ThemeUnitItem } from './types';

export const CreateBreakUnits = (): ThemeUnitItem[] => [
  {
    key: 0,
    name: 'xss',
    size: 375
  },
  {
    key: 1,
    name: 'xs',
    size: 425
  },
  {
    key: 2,
    name: 'sm',
    size: 768
  },
  {
    key: 3,
    name: 'md',
    size: 1024
  },
  {
    key: 4,
    name: 'lg',
    size: 1280
  },
  {
    key: 5,
    name: 'xl',
    size: 1920
  }
];

export const CreateBreakPoint = (): any => ({
  xs: 767,
  sm: 1023,
  md: 1440,
  lg: 1920,
  xl: 1921
});

export default {
  ...BreakPoint
};
